var site = site || {};
var generic = generic || {};

(function ($) {
  site.BuildRouletteGameV1 = site.BuildRouletteGameV1 || {};
  site.BuildRouletteGameV1.date = new Date();
  site.BuildRouletteGameV1.win_on;
  site.BuildRouletteGameV1.game_over;
  site.BuildRouletteGameV1.twenty_four_hours;
  site.BuildRouletteGameV1.number_of_tries;
  site.BuildRouletteGameV1.has_won = 0;
  site.BuildRouletteGameV1.is_pro_user = 0;
  site.BuildRouletteGameV1.spins_remaining;
  site.BuildRouletteGameV1.winning_offer;
  site.BuildRouletteGameV1.winning_product;
  site.BuildRouletteGameV1.offer_won;
  site.BuildRouletteGameV1.product_cats = [];
  site.BuildRouletteGameV1.available_products = [];
  site.BuildRouletteGameV1.probability;
  site.BuildRouletteGameV1.offer_array = [];
  site.BuildRouletteGameV1.available_offers = [];
  site.BuildRouletteGameV1.cart_offers;

  site.BuildRouletteGameV1.init = function () {
    $('body').addClass('roulette');
    site.BuildRouletteGameV1._getDom();
    site.BuildRouletteGameV1._getGameOver();
    site.BuildRouletteGameV1._getUserInfo();
    if (site.BuildRouletteGameV1.game_over !== true) {
      $(document).on('user.valid', function () {
        if (!site.BuildRouletteGameV1.is_pro_user) {
          site.BuildRouletteGameV1._getCookiesAndTries();
          site.BuildRouletteGameV1._getCart();
          site.BuildRouletteGameV1._getValidation();
        } else {
          site.BuildRouletteGameV1._getUnavailableMessage($('#pro-user-msg'));
        }
      });
    }
  };

  site.BuildRouletteGameV1._getDom = function () {
    site.BuildRouletteGameV1.nodes = {
      prize_copy: $('.prize'),
      main_copy: $('.main-copy'),
      win_msg: $('#win-message'),
      win_msg_discount: $('.win-msg-discount-copy'),
      win_msg_product: $('.win-msg-product-copy'),
      spin_btn: $('.play-button'),
      wheel: $('.roulette-wheel'),
      pointer: $('#roulette-pointer'),
      spin_again_msg: $('#spin-again-message'),
      spins_remaining_copy: $('.spins-remaining span'),
      loading: $('#roulette-game-loading'),
      game_available: $('#roulette-game-available'),
      copy_container: $('#roulette-copy-button-container'),
      offer_codes: $('#offer_codes').val(),
      roulette_signup: $('.roulette-signup'),
      end_date: $('#end_date').val(),
      end_time: $('#end_time').val(),
      probability_offer_1: $('#probability_offer_1').val(),
      probability_offer_2: $('#probability_offer_2').val(),
      probability_offer_3: $('#probability_offer_3').val(),
      probability_offer_4: $('#probability_offer_4').val(),
      probability_offer_5: $('#probability_offer_5').val()
    };
  };

  // check we can play the game
  site.BuildRouletteGameV1._getValidation = function () {
    // we have prizes and offers are still valid
    $(document).on('offer.valid', function () {
      // user has played the game in the last 24 hours, show msg
      if (site.BuildRouletteGameV1.twenty_four_hours) {
        site.BuildRouletteGameV1._getUnavailableMessage($('#maxed-out'));
      } else {
        // user can play game
        site.BuildRouletteGameV1._spinsRemaining();
        site.BuildRouletteGameV1._removeLoading(); // hide loading
        site.BuildRouletteGameV1.nodes.game_available.removeClass('hidden');

        // show message depending on how many times user has already played
        if (site.BuildRouletteGameV1.spins_remaining !== 3) {
          site.BuildRouletteGameV1.nodes.main_copy.addClass('hidden');
          site.BuildRouletteGameV1.nodes.spin_again_msg.removeClass('hidden');
        }
        site.BuildRouletteGameV1.nodes.spin_btn.on('click', function () {
          site.BuildRouletteGameV1._playGame();
        });
      }
    });
  };

  // play game
  site.BuildRouletteGameV1._playGame = function () {
    // check button is active
    if (!site.BuildRouletteGameV1.nodes.spin_btn.hasClass('disabled')) {
      site.BuildRouletteGameV1.nodes.wheel.addClass('spin_animate');
      site.BuildRouletteGameV1.nodes.spin_btn.addClass('disabled'); // disable the spin button
      // user has won - show winning prize
      if (site.BuildRouletteGameV1.number_of_tries >= site.BuildRouletteGameV1.win_on) {
        // spin to random prize
        site.BuildRouletteGameV1.nodes.wheel.addClass(
          site.BuildRouletteGameV1.winning_offer['offer_code']
        );
        // apply offer
        site.BuildRouletteGameV1._applyOffer();
      } else {
        // second spin
        if (site.BuildRouletteGameV1.nodes.wheel.hasClass('spin_again')) {
          site.BuildRouletteGameV1.nodes.wheel.addClass('spin_again_2');
        } else {
          site.BuildRouletteGameV1.nodes.wheel.addClass('spin_again');
          site.BuildRouletteGameV1._getSpinAgainMessage();
        }
        site.BuildRouletteGameV1._enableButton();
        if (site.BuildRouletteGameV1.number_of_tries < 3) {
          site.BuildRouletteGameV1.number_of_tries++;
        }
        site.BuildRouletteGameV1.spins_remaining--;
        document.cookie = 'game_tries=' + site.BuildRouletteGameV1.number_of_tries;
        setTimeout(function () {
          site.BuildRouletteGameV1._spinsRemaining();
          if ($(window).width() < 764) {
            $('html, body').animate({ scrollTop: 0 }, 1000);
          }
        }, 4000);
      }
      // pointer animation
      site.BuildRouletteGameV1.nodes.pointer.addClass('left-right');
      setTimeout(function () {
        site.BuildRouletteGameV1.nodes.pointer.removeClass('left-right');
      }, 4000);
    }
  };

  // function for returning a random number
  site.BuildRouletteGameV1._getRandomNumber = function (numberStart, numberRange, roundUp) {
    if (roundUp === true) {
      return Math.floor(Math.random() * numberRange + numberStart);
    } else {
      return (Math.random() * numberRange + numberStart).toFixed(2);
    }
  };

  // enable the spin button again, so the user can have another go
  site.BuildRouletteGameV1._enableButton = function () {
    setTimeout(function () {
      site.BuildRouletteGameV1.nodes.spin_btn.removeClass('disabled');
    }, 4000); // after 4 sec., enable btn
  };

  // show message promting user to spin again
  site.BuildRouletteGameV1._getSpinAgainMessage = function () {
    setTimeout(function () {
      site.BuildRouletteGameV1.nodes.main_copy.addClass('hidden');
      site.BuildRouletteGameV1.nodes.spin_again_msg.removeClass('hidden');
    }, 4000);
  };

  // show message if game is unavalable
  site.BuildRouletteGameV1._getUnavailableMessage = function (type) {
    site.BuildRouletteGameV1._removeLoading(); // hide loading
    site.BuildRouletteGameV1.nodes.game_available.addClass('hidden');
    type.removeClass('hidden');
    site.BuildRouletteGameV1.nodes.copy_container.addClass('mobile-message');
    $('.game-rules.mobile').empty();
    site.BuildRouletteGameV1._resizeMobileMsg();

    if ($(window).width() < 990) {
      $('html, body').animate({ scrollTop: 0 }, 1000);
    }
  };

  // show what the user has won
  site.BuildRouletteGameV1._getWinMessage = function () {
    // hide loading
    site.BuildRouletteGameV1._removeLoading(); // hide loading
    $('.game-rules.mobile').empty();

    // hide main part
    site.BuildRouletteGameV1.nodes.game_available.addClass('hidden');
    site.BuildRouletteGameV1.nodes.win_msg.removeClass('hidden');

    var product_in_cart = site.BuildRouletteGameV1._getCookie('prize_image');
    var discount_in_cart = site.BuildRouletteGameV1._getCookie('prize_discount');

    // show discount vs show product message
    if (product_in_cart) {
      site.BuildRouletteGameV1.nodes.win_msg_discount.remove();
      $('.win-msg-product-copy').before(
        '<img class="product-image" src="' + product_in_cart + '" />'
      );
      site.BuildRouletteGameV1.nodes.prize_copy.addClass('hidden');
    } else {
      site.BuildRouletteGameV1.nodes.win_msg_product.remove();
      site.BuildRouletteGameV1.nodes.prize_copy.html(discount_in_cart);
    }

    site.BuildRouletteGameV1.nodes.copy_container.addClass('mobile-message');
    site.BuildRouletteGameV1._resizeMobileMsg();

    if ($(window).width() < 764) {
      $('html, body').animate({ scrollTop: 0 }, 1000);
    }
  };

  // function for getting cookie
  site.BuildRouletteGameV1._getCookie = function (name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
  };

  // show number of spins left
  site.BuildRouletteGameV1._spinsRemaining = function () {
    // singular
    if (site.BuildRouletteGameV1.spins_remaining === 1) {
      $('.spin-remaining').removeClass('hidden').children('span').html(1);
      $('.spins-remaining').addClass('hidden');
      site.BuildRouletteGameV1.nodes.wheel.addClass('spin_again_2');
    } else {
      if (site.BuildRouletteGameV1.spins_remaining === 2) {
        // 2 spins left
        site.BuildRouletteGameV1.nodes.wheel.addClass('spin_again');
      }
      site.BuildRouletteGameV1.nodes.spins_remaining_copy.html(
        site.BuildRouletteGameV1.spins_remaining
      );
    }
  };

  site.BuildRouletteGameV1._getCart = function () {
    site.BuildRouletteGameV1.offer_array = site.BuildRouletteGameV1.nodes.offer_codes.split(',');
    // check user doesn't already have offer in cart
    generic.jsonrpc.fetch({
      method: 'trans.get',
      onSuccess: function (cart) {
        var cart_value = cart.getValue();

        if (cart_value) {
          site.BuildRouletteGameV1.cart_offers = cart_value.offerCodes;
          $.each(site.BuildRouletteGameV1.offer_array, function (index, value) {
            // user already has offer in cart
            if (
              $.inArray(value, site.BuildRouletteGameV1.cart_offers) !== -1 ||
              value === site.BuildRouletteGameV1.cart_offers
            ) {
              site.BuildRouletteGameV1.offer_won = value;
              site.BuildRouletteGameV1.has_won = 1;
            }
          });
          if (site.BuildRouletteGameV1.has_won === 0) {
            site.BuildRouletteGameV1._getOffers();
          } else {
            site.BuildRouletteGameV1.nodes.wheel.addClass(site.BuildRouletteGameV1.offer_won);
            site.BuildRouletteGameV1._getWinMessage();
          }
        } else {
          site.BuildRouletteGameV1._getUnavailableMessage($('#game-error'));
        }
      },
      onFailure: function () {
        site.BuildRouletteGameV1._getUnavailableMessage($('#game-error'));
      }
    });
  };

  site.BuildRouletteGameV1._getOffers = function () {
    // check all offers are valid
    var params = [{ offers: site.BuildRouletteGameV1.offer_array }];

    generic.jsonrpc.fetch({
      method: 'offers.getOffers',
      params: params,
      onSuccess: function (response) {
        site.BuildRouletteGameV1.available_offers = response.getValue();
        $.each(site.BuildRouletteGameV1.available_offers, function (key, value) {
          if (value == null) {
            // check offer exists
            delete site.BuildRouletteGameV1.available_offers[key]; // remove from object
          } else {
            // check all offers are active
            if (value['timing'] !== 'active') {
              delete site.BuildRouletteGameV1.available_offers[key]; // remove from object
            }
          }
        });

        // check all offers are valid
        if (
          Object.keys(site.BuildRouletteGameV1.available_offers).length ===
          site.BuildRouletteGameV1.offer_array.length
        ) {
          site.BuildRouletteGameV1._getPrize();
        } else {
          site.BuildRouletteGameV1._getUnavailableMessage($('#game-error'));
        }
      },
      onFailure: function () {
        site.BuildRouletteGameV1._getUnavailableMessage($('#game-error'));
      }
    });
  };

  // apply winning offer
  site.BuildRouletteGameV1._applyOffer = function () {
    var offer_code = site.BuildRouletteGameV1.winning_offer['offer_code'];
    var offer_value;
    var offer_params;

    if (site.BuildRouletteGameV1.winning_product) {
      offer_value = site.BuildRouletteGameV1.winning_product['product_ID'];
      offer_params = [
        {
          offer_code: offer_code,
          benefits: {
            ChoiceOfSkus: { choices: [site.BuildRouletteGameV1.winning_product['product_ID']] }
          }
        }
      ];
    } else {
      offer_value = site.BuildRouletteGameV1.winning_offer.benefits[0].value;

      offer_params = [
        {
          offer_code: offer_code,
          benefits: {
            PercentDiscount: { class: offer_value }
          }
        }
      ];
    }

    generic.jsonrpc.fetch({
      method: 'offers.apply',
      params: offer_params,
      onSuccess: function () {
        if (site.BuildRouletteGameV1.winning_product) {
          document.cookie =
            'prize_image=' + site.BuildRouletteGameV1.winning_product['product_image'];
          document.cookie = 'prize_discount=';
        } else {
          document.cookie =
            'prize_discount=' + site.BuildRouletteGameV1.winning_offer['description'];
          document.cookie = 'prize_image=';
        }

        // set twenty four hour cookie
        site.BuildRouletteGameV1.date.setTime(
          site.BuildRouletteGameV1.date.getTime() + (24 * 60 * 60 + 1) * 1000
        ); // in milliseconds
        document.cookie =
          'twenty_four=1;expires=' + site.BuildRouletteGameV1.date.toGMTString() + ';';
        document.cookie = 'game_tries=1'; // reset cookie

        // show message
        setTimeout(function () {
          site.BuildRouletteGameV1._getWinMessage();
        }, 3000);
      },
      onFailure: function () {
        site.BuildRouletteGameV1._getUnavailableMessage($('#game-error'));
      }
    });
  };

  site.BuildRouletteGameV1._getPrize = function () {
    site.BuildRouletteGameV1.probability = site.BuildRouletteGameV1._getRandomNumber(1, 100, false);
    site.BuildRouletteGameV1.probability_offer_2 =
      parseInt(site.BuildRouletteGameV1.nodes.probability_offer_1) +
      parseInt(site.BuildRouletteGameV1.nodes.probability_offer_2);
    site.BuildRouletteGameV1.probability_offer_3 =
      parseInt(site.BuildRouletteGameV1.probability_offer_2) +
      parseInt(site.BuildRouletteGameV1.nodes.probability_offer_3);
    site.BuildRouletteGameV1.probability_offer_4 =
      parseInt(site.BuildRouletteGameV1.probability_offer_3) +
      parseInt(site.BuildRouletteGameV1.nodes.probability_offer_4);
    site.BuildRouletteGameV1.probability_offer_5 =
      parseInt(site.BuildRouletteGameV1.probability_offer_4) +
      parseInt(site.BuildRouletteGameV1.nodes.probability_offer_5);

    if (
      site.BuildRouletteGameV1.probability <= site.BuildRouletteGameV1.nodes.probability_offer_1
    ) {
      // 25%
      site.BuildRouletteGameV1.winning_offer =
        site.BuildRouletteGameV1.available_offers[site.BuildRouletteGameV1.offer_array[0]];
    } else if (
      site.BuildRouletteGameV1.probability > site.BuildRouletteGameV1.nodes.probability_offer_1 &&
      site.BuildRouletteGameV1.probability <= site.BuildRouletteGameV1.probability_offer_2
    ) {
      // 15% - mini gift set
      site.BuildRouletteGameV1.winning_offer =
        site.BuildRouletteGameV1.available_offers[site.BuildRouletteGameV1.offer_array[1]];
    } else if (
      site.BuildRouletteGameV1.probability > site.BuildRouletteGameV1.probability_offer_2 &&
      site.BuildRouletteGameV1.probability <= site.BuildRouletteGameV1.probability_offer_3
    ) {
      // 20 - full size
      site.BuildRouletteGameV1.winning_offer =
        site.BuildRouletteGameV1.available_offers[site.BuildRouletteGameV1.offer_array[2]];
    } else if (
      site.BuildRouletteGameV1.probability > site.BuildRouletteGameV1.probability_offer_3 &&
      site.BuildRouletteGameV1.probability <= site.BuildRouletteGameV1.probability_offer_4
    ) {
      // 20 - 10% off
      site.BuildRouletteGameV1.winning_offer =
        site.BuildRouletteGameV1.available_offers[site.BuildRouletteGameV1.offer_array[3]];
    } else if (
      site.BuildRouletteGameV1.probability > site.BuildRouletteGameV1.probability_offer_4 &&
      site.BuildRouletteGameV1.probability <= site.BuildRouletteGameV1.probability_offer_5
    ) {
      site.BuildRouletteGameV1.winning_offer =
        site.BuildRouletteGameV1.available_offers[site.BuildRouletteGameV1.offer_array[4]];
    }

    site.BuildRouletteGameV1._chooseRandomProduct();
  };

  site.BuildRouletteGameV1._chooseRandomProduct = function () {
    // get random product SKU for full product/mini gift set
    $.each(Object.keys(site.BuildRouletteGameV1.winning_offer.benefits), function (key) {
      if (site.BuildRouletteGameV1.winning_offer.benefits[key].class === 'ChoiceOfSkus') {
        site.BuildRouletteGameV1.product_cats =
          site.BuildRouletteGameV1.winning_offer.benefits[key].choices;
      }
    });

    if (site.BuildRouletteGameV1.product_cats.length !== 0) {
      site.BuildRouletteGameV1._getRandomProduct(site.BuildRouletteGameV1.product_cats);
    } else {
      $(document).trigger('offer.valid');
    }
  };

  site.BuildRouletteGameV1._getRandomProduct = function (product_cats) {
    var params = {
      query_key: 'catalog-mpp',
      categories: product_cats
    };

    generic.jsonrpc.fetch({
      method: 'prodcat.querykey',
      params: [params],
      onSuccess: function (response) {
        var categories = response.getValue().categories;

        for (var element in categories) {
          for (var x in categories[element].products) {
            var product = categories[element].products[x];

            if (!product.skus) {
              continue;
            }

            var inventory_status = product.skus[0].INVENTORY_STATUS;

            if (
              inventory_status !== 5 &&
              inventory_status !== 7 &&
              inventory_status !== 8 &&
              inventory_status !== 9
            ) {
              site.BuildRouletteGameV1.available_products.push({
                product_ID: product.skus[0].SKU_BASE_ID,
                product_name: product.PROD_RGN_NAME,
                product_image: product.LARGE_IMAGE
              });
            }
          }
        }

        // get random product
        var random_sku = 0;

        if (!Object.keys(site.BuildRouletteGameV1.available_products).length) {
          site.BuildRouletteGameV1._getUnavailableMessage($('#game-error'));

          return;
        }
        if (Object.keys(site.BuildRouletteGameV1.available_products).length > 1) {
          random_sku = site.BuildRouletteGameV1._getRandomNumber(
            0,
            Object.keys(site.BuildRouletteGameV1.available_products).length,
            true
          );
        }
        if (random_sku >= Object.keys(site.BuildRouletteGameV1.available_products).length) {
          random_sku = Object.keys(site.BuildRouletteGameV1.available_products).length - 1;
        }
        site.BuildRouletteGameV1.winning_product =
          site.BuildRouletteGameV1.available_products[random_sku];
        $(document).trigger('offer.valid');
      },
      onFailure: function () {
        site.BuildRouletteGameV1._getUnavailableMessage($('#game-error'));
      }
    });
  };

  site.BuildRouletteGameV1._resizeMobileMsg = function () {
    var mobile_msg = $('#roulette-copy-button-container.mobile-message');

    if ($(window).width() < 764) {
      mobile_msg.css({ height: $('#roulette-wrapper').height() + 40 });
    } else {
      mobile_msg.css({ height: '100%' });
    }
  };

  site.BuildRouletteGameV1._getCookiesAndTries = function () {
    site.BuildRouletteGameV1.twenty_four_hours = parseInt(
      site.BuildRouletteGameV1._getCookie('twenty_four')
    );
    site.BuildRouletteGameV1.win_on = site.BuildRouletteGameV1._getRandomNumber(1, 3, true);

    // no cookie
    if (document.cookie.indexOf('game_tries=') < 0) {
      site.BuildRouletteGameV1.number_of_tries = 1;
      document.cookie = 'game_tries=1';
    } else {
      site.BuildRouletteGameV1.number_of_tries = site.BuildRouletteGameV1._getCookie('game_tries');
      if (site.BuildRouletteGameV1.number_of_tries > 3) {
        site.BuildRouletteGameV1.number_of_tries = 3;
      }
    }
    site.BuildRouletteGameV1.spins_remaining = 4 - site.BuildRouletteGameV1.number_of_tries;
  };

  site.BuildRouletteGameV1._getError = function () {
    // show error
    site.BuildRouletteGameV1._removeLoading(); // hide loading
    site.BuildRouletteGameV1._getUnavailableMessage($('#game-error'));
  };

  site.BuildRouletteGameV1._removeLoading = function () {
    if (!site.BuildRouletteGameV1.nodes.loading.hasClass('hidden')) {
      site.BuildRouletteGameV1.nodes.loading.addClass('hidden');
    }
  };

  site.BuildRouletteGameV1._getGameOver = function () {
    var date_now = Date.now();
    var end_date = Date.parse(
      site.BuildRouletteGameV1.nodes.end_date + 'T' + site.BuildRouletteGameV1.nodes.end_time
    );

    if (
      site.BuildRouletteGameV1.nodes.end_date != null &&
      site.BuildRouletteGameV1.nodes.end_time != null
    ) {
      if (date_now >= end_date) {
        site.BuildRouletteGameV1._getUnavailableMessage($('#game-over'));
        site.BuildRouletteGameV1.game_over = true;
        $('#game-over').append(site.BuildRouletteGameV1.nodes.roulette_signup);
        site.BuildRouletteGameV1.nodes.roulette_signup.removeClass('hide');
      }
    }
  };

  site.BuildRouletteGameV1._getUserInfo = function () {
    generic.jsonrpc.fetch({
      method: 'user.json',
      params: [],
      onSuccess: function (response) {
        if (response.getValue().isPro) {
          site.BuildRouletteGameV1.is_pro_user = 1;
        }
        $(document).trigger('user.valid');
      },
      onFailure: function () {
        $(document).trigger('user.valid');
      }
    });
  };

  jQuery(document).on('ready', function () {
    // change height of mobile pop up on window resize
    $(window).on('resize', function () {
      site.BuildRouletteGameV1._resizeMobileMsg();
    });

    return site.BuildRouletteGameV1.init();
  });
})(jQuery);
